import { Route } from '@angular/router';
import { DonationComponent } from './donation.component';
import { AuthGuard } from '../../shared/services';
import { DonationsListRoutes } from './donations-list/donations-list.routes';

export const DonationRoutes: Route[] = [
    {
      path: 'dons',
      component: DonationComponent,
      canActivate: [AuthGuard],
      children: [
        ...DonationsListRoutes
      ]
    }
  ];
